import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:8d6e2f68-83a4-44e3-a146-e6fc6cb7c141",
    aws_user_pools_id: "us-east-1_r47gwbRRd",
    aws_user_pools_web_client_id: "1f637goptiptombingb0irg6cp",
    Auth: {
      identityPoolId: "us-east-1:8d6e2f68-83a4-44e3-a146-e6fc6cb7c141",
      region: "us-east-1",
      userPoolId: "us-east-1_r47gwbRRd",
      userPoolWebClientId: "1f637goptiptombingb0irg6cp",
    },
    oauth: {
      domain: `whs-eap-prod-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://prod.na.safety-genie.whs.amazon.dev",
      redirectSignOut: "https://prod.na.safety-genie.whs.amazon.dev",
      scope: ["openid", "email", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
